export const MODULE = "auth";
export const Entity = {
  IS_AUTHENTICATED: "isAuthenticated",
  USER: "user",
  ADDRESSES: "addresses",
};
